import React, { useContext } from "react";
import { GetCommentsForObjectQuery } from "../../generated/graphql";
import { spacing } from "../../stitches.config";
import { formatDateString } from "../../utils/dates";
import { AuthContext } from "../Authorization/AuthContext";
import { FlexRow } from "../Common/__styles__/Layout";
import { MarkdownContainer } from "../Common/__styles__/MarkdownContainer";
import { Body } from "../Common/Typography";

type CommentType = NonNullable<
  GetCommentsForObjectQuery["getCommentsForObject"]
>[number];

export const Comment = ({ comment }: { comment: CommentType }) => {
  const { user, admin, publicUser } = useContext(AuthContext);
  const currentUser = user || admin || publicUser;

  const createdAt = formatDateString({
    dateString: comment.createdAt,
    format: "HH:mm ZZ",
  });

  let details = createdAt;
  let creator = "";
  if ("id" in comment.createdBy && comment.createdBy.id === currentUser?.id) {
    creator = "You";
  } else if (comment.createdBy.__typename === "Admin") {
    creator = "Forerunner";
  } else if (comment.createdBy.__typename === "User") {
    creator = `${comment.createdBy.firstName} ${comment.createdBy.lastName}`;
  } else if (comment.createdBy.__typename === "PublicUser") {
    details += ` ${comment.createdBy.userGroups.map(group => group.name).join(", ")} · `;
    creator = `${comment.createdBy.firstName} ${comment.createdBy.lastName}`;
  }

  return (
    <div style={{ padding: `${spacing.m}` }}>
      <FlexRow style={{ gap: `${spacing.s}` }}>
        <Body size="small" type="emphasis">
          {creator}
        </Body>
        <Body size="small" type="regular" color="contentSecondary">
          {details}
        </Body>
      </FlexRow>
      <Body size="default" type="regular" as="div">
        <MarkdownContainer
          markdown={comment.content}
          options={{ simpleLineBreaks: true }}
        />
      </Body>
    </div>
  );
};
